import { __awaiter } from "tslib";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LoginType, useSendSecureCodeMutation } from '@websky/graphql';
import { useAuthenticate } from '@features/auth';
import LoginTypeSelector from './LoginTypeSelector/LoginTypeSelector';
import { useTheme } from '../../../../theme';
import { Steps } from '../../../types';
import { getLoginTypeValue } from '../../../utils';
import { AUTH_DUPLICATES, removeFromSessionStorage } from '../../../../cache';
import { SafeHtml } from '@shared/ui';
import { default as BaseButton } from '../../../../BaseComponents/Button';
const LoginTypeSelectorForm = ({ loginTypes, login, code, stayLoggedIn, onSuccess, onError, setLoginData, setStep }) => {
    const { LoginTypeSelectorForm: css } = useTheme('LoginPage');
    const { t } = useTranslation('LoginPage');
    const [loginType, setLoginType] = useState(LoginType.Email);
    const [authenticate, { loading: authenticateLoading }] = useAuthenticate();
    const [sendCode, { loading: codeSending }] = useSendSecureCodeMutation();
    const onSubmit = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        if (loginType === LoginType.FFP) {
            removeFromSessionStorage(AUTH_DUPLICATES);
            try {
                yield authenticate({
                    variables: {
                        params: {
                            login: login,
                            loginType: loginType,
                            secureCode: code,
                            oneSession: !stayLoggedIn
                        }
                    }
                });
                onSuccess();
            }
            catch (e) {
                onError('');
            }
        }
        else if (loginType === LoginType.Email) {
            const email = getLoginTypeValue(loginTypes, LoginType.Email);
            setLoginData({
                login: email,
                loginType: LoginType.Email
            });
            try {
                const data = yield sendCode({
                    variables: {
                        params: {
                            login: email,
                            loginType: loginType
                        }
                    }
                });
                if ((_b = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.SendSecureCode) === null || _b === void 0 ? void 0 : _b.result) {
                    setStep(Steps.EnterCode);
                }
                else {
                    onError('');
                }
            }
            catch (e) {
                onError('');
            }
        }
    });
    const onBack = () => {
        removeFromSessionStorage(AUTH_DUPLICATES);
        setLoginData({ login: '', loginType: undefined });
        setStep(Steps.LogIn);
    };
    return (React.createElement("div", { className: css.root },
        React.createElement("div", { className: css.title }, t('Choose an account to enter')),
        React.createElement("div", { className: css.content },
            React.createElement(SafeHtml, { tag: "span", className: css.text, html: t('We found an account created with the email', {
                    email: getLoginTypeValue(loginTypes, LoginType.Email)
                }) }),
            React.createElement("div", { className: css.types }, loginTypes.map(item => (React.createElement(LoginTypeSelector, { key: item.type, type: item.type, value: item.value, selected: item.type === loginType, onClick: () => setLoginType(item.type) })))),
            React.createElement("div", { className: css.footer },
                React.createElement(BaseButton, { variant: "text", onClick: onBack }, t('Back')),
                React.createElement(BaseButton, { variant: 'action', onClick: onSubmit, isLoading: authenticateLoading || codeSending }, t('Continue'))))));
};
export default LoginTypeSelectorForm;
